import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { UserApi } from '../../fw/users/user-api';
import {JwtHelper} from "../../fw/helpers/jwt";
import 'rxjs/add/operator/toPromise';
import {AzureApiService} from "../../app/services/azure-api.service";
import {DtoLoginResult} from "../../app/shared/models/DtoLoginResult";

@Injectable()
export class UserService implements UserApi {
    jwtHelper: JwtHelper = new JwtHelper();

    constructor(private router: Router,
                private http: AzureApiService) { }

    signIn(username: string, password: string, rememberMe: boolean): Observable<DtoLoginResult> {
        return this.http.post<DtoLoginResult>(`login`, {username, password});
    }

    signOut(): Observable<any> {
        sessionStorage.clear();

        this.router.navigate(['/login'], {skipLocationChange: true});
        return Observable.of({});
    }

    isAuthenticated() {
        if (!sessionStorage.getItem('accessToken')) return false;
        else {
            return !this.jwtHelper.isTokenExpired(
                sessionStorage.getItem('accessToken')
            );
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/services/user.service.ts